import { DEFAULT_DESKTOP_POSITION } from "./constants";
import { getAppearanceLayout } from "./registry";
import type { ResolvedNoticeAppearance, ResolvedNoticeLayout } from "./types";

/**
 * The notice's layout: each choice the console or the host made, else the
 * style's own default (glass docks as a sheet with collapsible sections and a
 * paired footer; the other styles keep classic's layout). Every style keeps
 * checkboxes until switches are asked for.
 */
export const resolveNoticeLayout = (
  appearance: ResolvedNoticeAppearance,
): ResolvedNoticeLayout => {
  const defaults = getAppearanceLayout(appearance.style);
  return {
    mobileSheet: appearance.mobileLayout
      ? appearance.mobileLayout === "sheet"
      : defaults.sheet,
    desktopPosition: appearance.desktopPosition ?? DEFAULT_DESKTOP_POSITION,
    dimBackdrop: appearance.backdrop !== "none",
    collapsibleSections:
      appearance.collapsibleSections ?? defaults.collapsibleSections,
    pairedFooter: appearance.phoneFooter
      ? appearance.phoneFooter === "paired"
      : defaults.pairedFooter,
    switchControl: appearance.controlStyle
      ? appearance.controlStyle === "switch"
      : defaults.switchControl,
    motion: appearance.motion ?? true,
  };
};
